module.exports = __webpack_public_path__ + "static/media/games.092be606.png";